module.exports = __webpack_public_path__ + "static/img/1-_09.b7dc805.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/1-_09.png
// module id = Q/9M
// module chunks = 0